export const GET_ALL_CONTRACT_EMPLOYEE_TYPES = 'GET_ALL_CONTRACT_EMPLOYEE_TYPES';